<template>
  <div class="recomends">
    <div class="wrapper">
      <!-- <h2>Ваш выбор</h2> -->

      <div class="btns">
        <button @click="setRecommended('anime-serials')" :class="{ active: recommendedType === 'anime-serials' }">Многосерийные</button>
        <button @click="setRecommended('anime')" :class="{ active: recommendedType === 'anime' }">Фильмы</button>
      </div>
    </div>
    <div class="slider-wrapper">
      <div v-if="recommendsD.length" :style="`width:${(recommendsD.length + 1)  * 171}px;`" class="slider">
        <nuxt-link
          v-for="(item, i) in recommendsD" :key="`recommends-serials-slider-item-${item.anime_id}`"
          :to="`/film/${postUrl(item.anime_id, item.title_ru)}`"
          :title="`${item.title_ru} / ${item.title_en}`"
            tag="div"
          class="item"
        >
          <div class="poster">
            <nuxt-img
              v-if="isDesktop ? i < 7 : i < 3"
              :src="`/static_files/uploads/posters/${item.anime_id}.webp`"
              :alt="`${item.title_ru}`"
              fit="cover"
              preload
              format="webp"
              width="160"
              height="230"
              quality="70"
            />
            <nuxt-img
              v-else
              :src="`/static_files/uploads/posters/${item.anime_id}.webp`"
              :alt="`${item.title_ru}`"
              fit="cover"
              loading="lazy"
              format="webp"
              width="160"
              height="230"
              quality="70"
            />
            <!-- <img
              :data-src="filmPoster(item)"
              :alt="`${item.title_ru}`"
              src="/static_files/no-poster.png"
              class="lazyload"
            > -->
          </div>
          <strong>{{ item.title_ru }}</strong>
        </nuxt-link>
        <div @click="getMoreRecommended(++recommendedPage)" class="item">
          <div class="poster">
            <img
              src="/static_files/no-poster.png"
              data-src="/static_files/icons/more.png"
              class="lazyload"
              alt="Показать еще"
              style="width:160px;height:160px;object-fit:contain;opacity:0.75;"
            >
          </div>
          <strong v-if="!loading">Показать еще</strong>
          <strong v-else>Идет загрузка...</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  watch: {
    recommendedType() {
      const slider = document.querySelector('.slider-wrapper')
      if (slider) {
        slider.scrollTo(0,0)
      }
    },
  },
  computed: mapState(['isDesktop']),
  data() {
    return {
      recommendsD: [],
      recommends: null,
      recommendedType: 'anime-serials',
      recommendedPage: 1,
      loading: false,
    }
  },
  async fetch() {
    const { data } = await this.$axios.get(`/api/collaps-top?page=0`)

    this.recommends = data
    this.recommendsD = data['anime-serials'] ? data['anime-serials'] : []
  },
  methods: {
    async getMoreRecommended(page) {
      if (this.loading) return
      this.loading = true
      const { data } = await this.$axios.get(`/api/collaps-top?page=${page}&category=${this.recommendedType}`)
      this.loading = false
      if (data.error) {

      } else {
        const items = this.recommendsD.concat(data)
        this.recommendsD = items
      }
    },
    setRecommended(type = 'serials') {
      this.recommendedType = type
      this.recommendsD = this.recommends[type]
    },
  },
}
</script>

<style lang="stylus">
@keyframes shimmer
  100%
    transform: translateX(100%)

.recomends
  margin: 0px 0px 30px
  // height: 340px
  .wrapper
    width: 100%
    overflow-x: auto
    h2
      margin-bottom: 15px
    .btns
      // padding: 0px 10px
      margin-bottom: 10px
      width: 250px
      button
        margin-right: 7px
  .slider-wrapper
    width: 100%
    height: 320px
    overflow-x: auto
    &::-webkit-scrollbar-track
      height: 14px
      background: #fff
    &::-webkit-scrollbar
      height: 14px
    &::-webkit-scrollbar-thumb
      background: #fff
    &:hover::-webkit-scrollbar-thumb
      background: #e9e9e9
    .slider
      .item
        display: inline-block
        margin: 0px 5px
        position: relative
        cursor: pointer
        button
          width: 160px
          height: 230px
        a, strong
          display: inline-block
          width: 160px
          padding: 10px
          text-overflow: ellipsis
          white-space: nowrap
          overflow: hidden
        .poster
          position: relative
          width: 160px
          height: 230px
          background: #f1f1f1
          overflow: hidden
          border-radius: 12px
          &::after
            content: ''
            position: absolute
            top: 0
            right: 0
            bottom: 0
            left: 0
            transform: translateX(-100%)
            background-image: linear-gradient(
              90deg,
              rgba(#444, 0) 0,
              rgba(#444, 0.2) 20%,
              rgba(#444, 0.5) 60%,
              rgba(#444, 0)
            )
            animation: shimmer 2s infinite
          img
            position: relative
            width: 100%
            min-height: 100%
            object-fit: cover
            z-index: 1
</style>